import React, { Component } from 'react';
import ListBlock from './components/ListBlock';

var List = React.createClass({
	getInitialState: function(){
		console.log('this.props.data', this.props.data)
    return {
			height: this.props.height,
			width: this.props.width,
			bloksOnPage: typeof this.props.data != 'undefined' ? !this.props.mobile ? this.props.height * this.props.width : this.props.data.length : 0,
      page: 0
    }
  },
	componentWillReceiveProps: function(nextProps) {
		if (this.state.height != nextProps.height && this.state.width != nextProps.width) {
			this.setState({
				height: nextProps.height,
				width: nextProps.width,
		    bloksOnPage: nextProps.height * nextProps.width,
		  });
		}
	},
	handleNextPage: function(){
		this.setState({
			page: this.state.page + 1
		})
	},
	handleBackPage: function(){
		this.setState({
			page: this.state.page - 1
		})
	},
	handleClickElement: function(data){
		this.props.actionSaveField({
			nav: 'next',
			data: data
		});
	},
	handleClickReload: function(data){
		location.reload();
	},
	actionBack: function(){
		this.props.actionSaveField({nav: 'back'})
	},
	render: function(){
		var bloksOnPage = this.state.bloksOnPage,
				data        = this.props.data || [],
				page        = this.state.page,
				mobile      = this.props.mobile,
				actionBack  = this.actionBack,
				handleBackPage = this.handleBackPage,
				handleNextPage = this.handleNextPage,
				handleClickReload = this.handleClickReload,
				handleClickElement = this.handleClickElement,
				index       = page * (bloksOnPage - 1 ),
				block       = {},
				backPage    = typeof this.props.backPage != 'undefined' ? true : false,
				backButton  = page > 0 || backPage,
				nextButton  = data.length > (bloksOnPage * (page + 1)),
				// lastBlock   = (nextButton && backButton) ? 2 : 1,
				lastBlock   = backButton ? 2 : 1,
				styleClass  = 'List ' + ((this.props.height == this.props.width) ? (this.props.height == 3 ? 'three' : (this.props.height == 4) ? 'four' : 'unknown') : 'unknown');

		return (
	      <div className={styleClass}>
						{[...Array(Number(bloksOnPage))].map((x, i) => {
							index = (i == 0) ? index : index + 1;
							block = data[index] ? data[index] : {name: '', id: index, empty: true};

							if(i == (bloksOnPage - lastBlock) && backButton && !mobile){
								lastBlock = lastBlock - 1;
								backButton = false;
								if(backPage && page == 0){
									return(
										<ListBlock
											back={true}
											key={index}
											handleBackPage={actionBack}
										/>
									);
								}else{
									return(
										<ListBlock
											back={true}
											key={index}
											handleBackPage={handleBackPage}
										/>
									);
								}

							}else if(i == (bloksOnPage - lastBlock) && !nextButton && !mobile){

								return(
									<ListBlock
										reload={true}
										key={index}
										handleBackPage={handleClickReload}
									/>
								);

							}else if(i == (bloksOnPage - lastBlock) && nextButton && !mobile){
								lastBlock = lastBlock - 1;
								nextButton = false;
								return(
									<ListBlock
										next={true}
										key={index}
										handleNextPage={handleNextPage}
									/>
								);
							}else{
								return(
									<ListBlock
										data={block.VacancyName}
										key={block.id}
										actionClickElement={handleClickElement}
									/>
								);
							}

				  	})}
	      </div>
		);
	}
})

export default List;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/List/index.jsx
 **/